import { z } from 'zod';

/**
 * Module A · BDI = Benefícios e Despesas Indiretas.
 *
 * All four rates are stored and transmitted as basis points
 * (integer; 1% = 100 bp) — no floats for percentages anywhere.
 * `totalBdiPct` and `totalBdiMultiplier` are derived in the service
 * before serialization, never persisted.
 */

export const bdiConfigSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  adminPctBp: z.number().int().min(0).max(10_000),
  riskPctBp: z.number().int().min(0).max(10_000),
  lucroPctBp: z.number().int().min(0).max(10_000),
  impostosPctBp: z.number().int().min(0).max(10_000),
  // BDI-03 fix · canteiro + contingência. Persisted by the project wizard
  // (6 components) but not yet edited by BdiPanel (4 components), so they're
  // optional on read-back. Absent/NULL is treated as 0 by the service.
  canteiroPctBp: z.number().int().min(0).max(10_000).optional(),
  contingenciaPctBp: z.number().int().min(0).max(10_000).optional(),
  totalBdiPct: z.number(),
  totalBdiMultiplier: z.number(),
  notes: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type BdiConfig = z.infer<typeof bdiConfigSchema>;

export const upsertBdiConfigRequestSchema = z.object({
  adminPctBp: z.number().int().min(0).max(10_000),
  riskPctBp: z.number().int().min(0).max(10_000),
  lucroPctBp: z.number().int().min(0).max(10_000),
  impostosPctBp: z.number().int().min(0).max(10_000),
  notes: z.string().max(500).nullable().optional(),
});
export type UpsertBdiConfigRequest = z.infer<typeof upsertBdiConfigRequestSchema>;
